import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import type { FormActionsPropsInterface } from './types/form-actions.types';

/**
 * Form actions is a simple container for actions associated with a form. The component itself does
 * nothing other than provide layout when nested in a
 * `Form` component.
 *
 * @related [`Form`]
 * @since 8.0.0
 */
export const FormActions = forwardRef<HTMLDivElement, FormActionsPropsInterface>(
  (props: FormActionsPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="FormActions"
        className={cx('c11n', css(cssProp), className)}
        {...rest}
      />
    );
  },
);

FormActions.displayName = 'FormActions';
